// removed by extract-text-webpack-plugin
module.exports = {"vpUploadVideoButton":"vpUploadVideoButton___-ZuGu","vpVisuallyHidden":"vpVisuallyHidden___E2Dcm","vpInputDisabled":"vpInputDisabled___1y7oA","vpRecordButtonStyle":"vpRecordButtonStyle___3qhn9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoUploadButton.module.less
// module id = 3435
// module chunks = 30